function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "365px",
    height: "363px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eeedee",
    d: "M 42.5,-0.5 C 135.5,-0.5 228.5,-0.5 321.5,-0.5C 354.443,14.1494 368.776,39.4828 364.5,75.5C 364.5,124.5 364.5,173.5 364.5,222.5C 363.489,256.01 362.322,289.677 361,323.5C 352.948,342.295 339.114,354.795 319.5,361C 299.662,361.168 279.996,361.668 260.5,362.5C 207.5,362.5 154.5,362.5 101.5,362.5C 82.0043,361.668 62.3376,361.168 42.5,361C 25.0245,355.193 12.1912,344.026 4,327.5C 3.66667,324.5 3.33333,321.5 3,318.5C 1.49953,272.345 0.332861,226.345 -0.5,180.5C -0.5,159.5 -0.5,138.5 -0.5,117.5C 0.06736,91.9723 0.900693,66.3056 2,40.5C 9.71169,20.9558 23.2117,7.28913 42.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef4644",
    d: "M 51.5,37.5 C 137.834,37.7578 224.168,38.2578 310.5,39C 316.799,40.9633 321.632,44.7966 325,50.5C 327,136.833 327,223.167 325,309.5C 321.164,314.368 316.997,318.868 312.5,323C 225.5,325 138.5,325 51.5,323C 46.6667,319.5 42.5,315.333 39,310.5C 37.0069,224.167 37.0069,137.833 39,51.5C 42.3193,46.0175 46.486,41.3508 51.5,37.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.99140cad665d3f0151687ea13e3abc74.svg";
export { ForwardRef as ReactComponent };